import Modal from 'developer_components/newModal';
import HotelSearch from 'components/hotel-search.dev';
import {serialize} from 'methods/utils';
import ModalDialog from 'components/modal-dialog.dev';

function ModalRecallCreate(options) {
    const $wrapped = Modal.createFromHTML(
        `<div class="header">
            <div class="close js-modalClose">
                <div class="icon icon-close-circle">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 8.586L7.172 5.757L5.757 7.172L8.586 10L5.757 12.828L7.172 14.243L10 11.414L12.828 14.243L14.243 12.828L11.414 10L14.243 7.172L12.828 5.757L10 8.586Z" fill="#D4D2D8"/>
                    </svg>
                </div>
            </div>
            <h2 class="title">Отзыв</h2>
        </div>
        <div class="content">
            <form action="/about/recalls/save_recall/" class="Form Form-valid" novalidate="">
                <input type="hidden" name="redirect" value="1">
                <input class="js-searchInput" type="hidden" name="hotel_id" value="">
                <div class="Form__group">
                    <div class="Form__input-wrapper">
                        <div class="Form__label">
                            <label for="Form-application-name" class="Form__label">Ваше имя:</label>
                        </div>
                        <input type="text" name="name" placeholder="Введите ваше имя"
                               id="Form-application-name" class="Form__input Form__input--border"
                               required="required"
                               data-field-type="matches"
                               data-field-params="[а-яёa-z\-\s]+"
                               data-field-modifiers="i" data-alert_name="имя">
                    </div>
                </div>
                <div class="Form__group">
                    <div class="Form__input-wrapper js-hotelWrapper">
                        <div class="Form__label">
                            <label for="Form-application-hotel" class="Form__label">Название вашего объекта:</label>
                        </div>
                        <div class="Form__input-box">
                            <input type="text" name="hotel" placeholder="Введите название вашего отеля"
                                   id="Form-application-hotel" class="Form__input Form__input--search Form__input--border js-hotelInput"
                                   required="required"
                                   autocomplete="off"
                                   data-field-type="matches"
                                   data-field-params="[а-яёa-z\-\s]+"
                                   data-field-modifiers="i" data-alert_name="название отеля">
                            <button class="Form__input-cross js-searchClose" type="button" tabindex="-1"></button>
                            <div class="Form-application-hotel__box"></div>
                        </div>
                    </div>
                </div>
                <div class="Form__group">
                    <div class="Form__textarea-wrapper">
                        <div class="Form__label">
                            <label for="Form-application-comment" class="Form__label">Отзыв:</label>
                        </div>
                        <textarea name="mes" id="Form-application-comment" placeholder="Напишите ваш отзыв"
                                  class="Form__textarea Form__textarea--border"
                                  required="required"
                                  data-field-type="matches"
                                  data-alert_name="отзыв"></textarea>
                    </div>
                </div>
                <div class="Form__group Form__label grey">Поставьте оценку работе нашего сервиса</div>
                <div class="Form__group-stars">
                    <div class="Form__group-stars__rating">
                        <input type="radio" id="star5" name="stars" value="5" /><label for="star5" title="Отлично"></label>
                        <input type="radio" id="star4" name="stars" value="4" /><label for="star4" title="Хорошо"></label>
                        <input type="radio" id="star3" name="stars" value="3" /><label for="star3" title="Удовлетворительно"></label>
                        <input type="radio" id="star2" name="stars" value="2" /><label for="star2" title="Плохо"></label>
                        <input type="radio" id="star1" name="stars" value="1" checked/><label for="star1" title=Отвратительно></label>
                    </div>
                </div>
                <div class="Form__group Form__group--button">
                    <input type="text" name="check-html" value=""
                           class="Form__input is-special">
                    <input type="hidden" name="type" value=""
                           class="Form__input is-special">
                    <button class="Button js-submitButton">Оставить отзыв</button>

                    <div class="Form__policy">
                        <p>Нажимая кнопку, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/guest_offer/">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                    <p class="Form__alert js-formAlert"></p>
                </div>
            </form>
        </div>`
    );

    Modal.call(this, $wrapped, options);

    this.$form = this.$element.querySelector('form');
    this.addEventListener(this.$form, 'submit', this._onFormSubmitEvent.bind(this));

    // поиск в модалке
    this.hotelSearch = new HotelSearch({
        container:      '.js-hotelWrapper',
        dataContainer:  'input[name=hotel_id]',
        formContainer:  this.$form,
        searchInput:    '#Form-application-hotel',
        url: '/about/recalls/search_results/',
        mode: 'hotelSelect'
    });

    this.hotelSearch.init();

    // слушатель валидации полей формы
    let fields = ['name', 'hotel', 'comment'];
    fields.forEach(field => {
        let elem = document.querySelector(`#Form-application-${field}`)
        elem.addEventListener('input', () => {
            elem.classList.remove('error')
            if (!elem.value) {
                elem.classList.add('error')
            }
        })

    });

    // показываем сообщения из сессии
    new ModalDialog({getSession: true});
}

ModalRecallCreate.prototype = Object.create(Modal.prototype);
Object.defineProperty(ModalRecallCreate.prototype, 'constructor', {
    value: ModalRecallCreate,
    writable: true,
    enumerable: false,
});

ModalRecallCreate.prototype.submit = function() {
    const formData = new FormData(this.$form);

    return fetch(this.$form.action, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw r;
        }

        return r;
    });
}

ModalRecallCreate.prototype._onFormSubmitEvent = function(e) {
    e.preventDefault();
    e.stopPropagation();

    this.submit()
        .then((r) => {
            new ModalDialog({
                header: 'Спасибо!',
                message: 'Ваш отзыв добавлен и после модерации будет опубликован.',
                autoClose: false,
                setSession: true,
            });

            // редирект
            location.href = r.redirect;
        })
        .catch((r) => {
            new ModalDialog({
                header: 'Ошибка!',
                message: r.message,
                autoClose: false,
            });
            checkFieldsFilled();
        });
}

function checkFieldsFilled() {
    let fields = ['name', 'hotel', 'comment'];
    fields.forEach(field => {
        let elem = document.querySelector(`#Form-application-${field}`)
        if (!elem.value) {
            elem.classList.add('error')
        }

    })
}

export default ModalRecallCreate;
